import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy, signal } from '@angular/core';
import { BehaviorSubject  } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface SessionData_Response {
  UserName: string;
  UserId: string;
  DsnSequence: number;
  DefendantNumber: number;
  AllowPoliceMaintenance: boolean;
  PoliceDepartment: string;
  AllowUploadFromExAgency: boolean;
  AllowCreateCaseFromExAgency: boolean;
}

export const Default_SessionUserDetails: SessionData_Response = {
  UserName: '',
  UserId: '',
  DsnSequence: 0,
  DefendantNumber: 0,
  AllowPoliceMaintenance: false,
  PoliceDepartment: '',
  AllowUploadFromExAgency: false,
  AllowCreateCaseFromExAgency: false
}

const UPDATE_INTERVAL_MS = 60 * 1000;

@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnDestroy {

  private refreshTimer: any;
  private sessionSubject = new BehaviorSubject<SessionData_Response>(Default_SessionUserDetails);
  private baseUrl: string;

  constructor(private httpClient: HttpClient) {
    this.baseUrl = environment.api.url;
    this.refreshTimer = setInterval(() => this.refreshUser(), UPDATE_INTERVAL_MS);
  }

  get currentSession$() {
    return this.sessionSubject.asObservable();
  }

  ngOnDestroy() {
    clearInterval(this.refreshTimer);
  }

  public validateSession() {
    const url = `${this.baseUrl}WebServices/SessionService.asmx/ValidateSession`
    return this.httpClient.post<string>(url, {});
  }

  private refreshUser() {
    this.getuserDetails().subscribe(data => {
      this.sessionSubject.next(data);
    });
  }
  
  public getuserDetails() {
    const url = `${this.baseUrl}WebServices/SessionService.asmx/GetUserDetails`
    return this.httpClient.post<SessionData_Response>(url, {});
  }
  
  public logout() {
    const url = `${this.baseUrl}WebServices/SessionService.asmx/Logout`
    this.httpClient.post<SessionData_Response>(url, {}, { params: { 'showLoader': true } }).subscribe(() => {
      this.sessionSubject = new BehaviorSubject<SessionData_Response>(Default_SessionUserDetails);
    });
  }

  public intializeSessionAfterLogin(userSession: SessionData_Response) {
      this.sessionSubject.next(userSession);
  }
}
